// extracted by mini-css-extract-plugin
export default {"wrapper":"DashBoardLayout_wrapper__BM+G9","outlet":"DashBoardLayout_outlet__k+GCE","container":"DashBoardLayout_container__zfs4d"};